import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { slide as Menu } from "react-burger-menu";

import { useMenuData } from "../../lib/hooks";
import { useDrupalSettings } from "../../lib/DrupalSettings";

import NavMenuLevel from "../NavMenuLevel";
import IcomoonIcon from "../IcomoonIcon";
import PhosphorIcon from "../PhosphorIcon";
import css from "./NavMenu.module.scss";

/* eslint-disable react/forbid-prop-types */

const HOMEPAGE_TITLE = "Gallery guides and podcasts";
const SUBPAGE_TITLE = "Gallery guides";
const NavMenuTitle = ({ location, themeConfig, limitGuide = null }) => {
  const interior = (
    <>
      {location.pathname === "/" && limitGuide === null && HOMEPAGE_TITLE}
      {(location.pathname !== "/" || limitGuide !== null) && SUBPAGE_TITLE}
    </>
  );

  return (
    <p className={css.appHeaderTitle}>
      {themeConfig.homePage === 1 && <Link to="/">{interior}</Link>}
      {themeConfig.homePage !== 1 && <a href="/">{interior}</a>}
    </p>
  );
};

NavMenuTitle.propTypes = {
  location: PropTypes.any.isRequired,
  themeConfig: PropTypes.any.isRequired,
  limitGuide: PropTypes.number
};

NavMenuTitle.defaultProps = {
  limitGuide: null
};

const NavMenu = ({
  className = "",
  menuPadding = false,
  limitGuide = null
}) => {
  const { state: drupalSettings } = useDrupalSettings();
  const location = useLocation();
  const menuTree = useMenuData();
  const [isOpen, setIsOpen] = React.useState(false);
  const [isFixed, setIsFixed] = React.useState(false);
  const [isScrolled, setIsScrolled] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  React.useEffect(() => {
		const button = document.getElementById("react-burger-menu-btn");
		if (button) {
			button.textContent = "Menu";
			button.classList.add(css.menuButton);
		}
	}, [isFixed]);


  const menuStyles = {
  bmBurgerButton: {
    boxSizing: "border-box",
    width: "auto",
    right: "0px",
    top: isFixed ? "0rem" : "3.5rem",
    transition: "top 0.3s ease",
    zIndex: 1000
  },
  bmMenuWrap: {
    position: "absolute",
    top: isFixed ? "0" : "4.5rem",
    height: "auto",
    width: "370px",
		top: "5rem",
    transition: "top 0.3s ease",
    overflow: "visible"
	},
  bmMenu: {
    background: "#e4e5e5",
    padding: "2rem",
    margin: "0",
    fontSize: "1.15em",
		color: "#313435",
		"border-radius": "1rem"
  },
  bmOverlay: { background: "rgba(0,0,0,0.3)", inset: "0" }
};


  const themeConfig = drupalSettings.slnswAudioGuideTheme || {
    homePage: 1,
    audioGuideNids: []
  };

  const closeMenu = () => {
    setTimeout(() => setIsOpen(false), 100);
  };

  return (
    <header
      className={[
        css.app_header,
        isFixed ? css.app_header_fixed : "",
        className || "",
        menuPadding ? css.app_header_padded : ""
      ].join(" ")}
    >
      <div className={css.gridContainer}>
        <div className={css.siteBranding}>
          <a
            className={css.appHeaderLogo}
            href="https://www.sl.nsw.gov.au"
            title="State Library of NSW website"
            tabIndex="0"
          >
            <img
              src="/themes/custom/slnsw_audio_guide_theme/logo.fff.svg"
              alt="State Library of NSW logo"
              className={css.logo_link}
            />
          </a>

          <NavMenuTitle
            location={location}
            themeConfig={themeConfig}
            limitGuide={limitGuide}
          />

      {limitGuide === null && (
				<Menu
					styles={menuStyles}
					customBurgerIcon={
						<button
							type="button"
							className={`${css.menuButton} ${isOpen ? css.menuButtonOpen : ''}`}
						>
							{isOpen ? (
								<>
									<span className={css.menuLabel}>Close</span>
									<PhosphorIcon name="x" />
								</>
							) : (
								<>
									<span className={css.menuLabel}>Menu</span>
									<PhosphorIcon name="list" />
								</>
							)}
						</button>
					}
					customCrossIcon={false}
					burgerButtonClassName={css.menu_burger_icon}
					isOpen={isOpen}
					onOpen={() => setIsOpen(true)}
					onClose={() => setIsOpen(false)}
					right
				>
					<NavMenuLevel
						items={menuTree}
						drupalSettings={drupalSettings}
						closeMenu={closeMenu}
					/>
				</Menu>


      )}
      </div>
      </div>
    </header>
  );
};

NavMenu.propTypes = {
  className: PropTypes.string,
  menuPadding: PropTypes.bool,
  limitGuide: PropTypes.number
};

NavMenu.defaultProps = {
  className: "",
  menuPadding: false,
  limitGuide: null
};

export default NavMenu;
